import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { selectPageType } from '../selectors/page';

function getIsMainPage(): boolean {
  return window.location.pathname === '/' && !window.location.hostname.startsWith('my.');
}

export function useIsMainPage(): boolean {
  const pageType = useSelector(selectPageType);
  // SSR and the first client render must use the same source of truth.
  const [isMainPage, setIsMainPage] = useState(() => pageType === 'main');

  useEffect(() => {
    const update = () => setIsMainPage(getIsMainPage());

    window.addEventListener('popstate', update);

    const originalPushState = history.pushState.bind(history);
    const originalReplaceState = history.replaceState.bind(history);

    history.pushState = (...args: Parameters<History['pushState']>) => {
      originalPushState(...args);
      update();
    };

    history.replaceState = (...args: Parameters<History['replaceState']>) => {
      originalReplaceState(...args);
      update();
    };

    return () => {
      window.removeEventListener('popstate', update);
      history.pushState = originalPushState;
      history.replaceState = originalReplaceState;
    };
  }, []);

  return isMainPage;
}
